import { render, staticRenderFns } from "./CalculatedPrice.vue?vue&type=template&id=8289f6c8&scoped=true"
import script from "./CalculatedPrice.vue?vue&type=script&lang=js"
export * from "./CalculatedPrice.vue?vue&type=script&lang=js"
import style0 from "./CalculatedPrice.vue?vue&type=style&index=0&id=8289f6c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8289f6c8",
  null
  
)

export default component.exports